import { fetchAddressService } from "../services/fetchAddress.service";
import { useMutation } from "react-query";
import { AxiosError } from 'axios';

export interface AddressItem {
    premises: string;
    label: string;
}

export interface AddressResponse {
    query: string;
    normalizedQuery: string;
    searchPk: string;
    count: number;
    items: AddressItem[];
}

export const useFetchAddress = () => {

    return useMutation<AddressResponse, AxiosError, string>(fetchAddressService);

}

export default useFetchAddress;